import { TemplateEntityModel } from "src/store/models/entity/understandingTemplate/entity";
import { TemplateHelperModel } from "src/store/models/entity/understandingTemplate/helper";
import { TemplateListModel } from "src/store/models/entity/understandingTemplate/list";

export const encooUnderstandingTemplateModels = {
  entity: TemplateEntityModel,
  helper: TemplateHelperModel,
  list: TemplateListModel,
};
